import React from 'react'
import MuiTable from '../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_PEDIDO_CAMIONES_EN_CALADO } from '../../../config/tables'

export function TablaPedidosBrutoView () {
  return <MuiTable id={TABLA_PEDIDO_CAMIONES_EN_CALADO} />
}
